<app-header class="non-transparent" />
@defer (on idle; hydrate on viewport) {
  <app-mini-cart></app-mini-cart>
}

<main id="lbx-wrapper">
  @if (variantRes.hasValue()) {
    <app-product [variants]="variantRes.value()" />
  } @else if (variantRes.isLoading()) {
    <app-product-skeleton />
  } @else if (variantRes.error()) {
    <app-not-found-content />
  }
</main>

<app-footer></app-footer>
